import {Button, Row, Col, Input, InputNumber, message, Select} from 'antd';
import {useState} from 'react';
import {insertPlant} from "../../api/Api";
import {StrainType, getOptions} from "../../api/Constants";
import {StrainSelectWidget} from "./StrainSelectWidget";


const {TextArea} = Input;

export const NewPlant = ({roomId, batch, io, props}) => {
    const [name, setName] = useState(undefined);
    const [strain, setStrain] = useState(StrainType.Indica);
    const [description, setDescription] = useState(undefined);
    const [metricTag, setMetricTag] = useState(undefined);
    const [disabled, setDisabled] = useState(false);
    const [messageApi, contextHolder] = message.useMessage()
    const [plantStrain, setPlantStrain] = useState(undefined);
    const [count, setCount] = useState(undefined);

    const {onRefresh} = io;

    const onNewPlant = () => {
        setDisabled(true);
        const strainId = plantStrain.id;
        insertPlant(name, description, strain, metricTag, roomId, strainId, count, batch.id).then(r => {
            setDisabled(false);
            if (onRefresh) { onRefresh() }
            clearForm();
            messageApi.open({
                type: 'success',
                content: 'Plant Created'
            })
        }).catch(e => {
            setDisabled(false);
            console.log(`failed to create plant ${e}`)
            messageApi.open({
                type: 'success',
                content: `failed to create plant ${e}`
            })
        })
    }

    const clearForm = () => {
        setName(undefined);
        setStrain(undefined);
        setDescription(undefined);
        setMetricTag(undefined);
        setPlantStrain(undefined);
        setCount(undefined);
    }

    const onNameChange = (e) => {
        setName(e.target.value);
    }

    const onStrainChange = (val) => {
        setStrain(val);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const onMetricChange = (e) => {
        setMetricTag(e.target.value);
    }

    const onPlantStrainChange = (val) => {
        setPlantStrain(val);
    }

    const onCountChange = (val) => {
        setCount(val);
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const strainOptions = getOptions(StrainType) ();
    const submitDisabled = disabled || (name === undefined) || (description === undefined) || (strain === undefined) || (count === undefined)
        || (plantStrain === undefined) || (batch === undefined);

    return <div>
        {contextHolder}
        <Row style={rowStyle}>
            <Col span={12}>
                <Input value={name} onChange={onNameChange} placeholder={"Name"} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={12}>
                <TextArea value={description} onChange={onDescriptionChange} placeholder={"Description"} rows={4} maxLength={256} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={12}>
                <Col><Select options={strainOptions} placeholder={"strain"} onChange={onStrainChange} value={strain} /></Col>
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={12}>
                <Input value={metricTag} onChange={onMetricChange} placeholder={"Metrc Tag"} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <InputNumber placeholder={'Count'} value={count} min={0} precision={0} onChange={onCountChange} />
        </Row>
        <Row style={rowStyle}>
            <StrainSelectWidget strain={plantStrain} io={io} onSelect={onPlantStrainChange} defaultActive={true} />
        </Row>
        <Row style={rowStyle}>
            <Button onClick={onNewPlant} disabled={submitDisabled}>Create</Button>
        </Row>
    </div>
}